import { FormInstance } from "antd";
import { useCallback, useEffect, useMemo, useState } from "react";
import FillableFormsService from "../../../../services/administration/fillableForms";

export const useGetInitialValues = (
  id: string | null | undefined,
  form: FormInstance,
) => {
  const [isLoading, setIsLoading] = useState<boolean>(!!id);

  const loadData = useCallback(async () => {
    try {
      if (id) {
        const res = await FillableFormsService.fetch(id);

        const { fileName, fileContentType, fileSizeBytes } = res;

        const data = { ...res };

        if (fileName) {
          data.file = [
            {
              name: fileName,
              type: fileContentType,
              size: fileSizeBytes,
            },
          ];
        }

        setIsLoading(false);

        form.setFieldsValue(data);
      }
    } catch {
      setIsLoading(false);
    }
  }, [id, form]);

  const itialValues = useMemo(
    () => ({
      visibility: 0,
    }),
    [],
  );

  useEffect(() => {
    loadData();
  }, [loadData]);

  return { isLoading, itialValues };
};
